import { render, staticRenderFns } from "./WebUICard.vue?vue&type=template&id=6a122383&"
import script from "./WebUICard.vue?vue&type=script&lang=js&"
export * from "./WebUICard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports